<template>
  <div class="pb-4">
    <v-layout row justify-end wrap>
      <SearchByTag />
      <SearchByDate />
      <SearchByUser v-if="isAdmin" />
      <v-spacer />
      <v-flex xs12 sm6 md3 xs-off>
        <v-text-field
          v-model.trim="searchText"
          :append-outer-icon="'search'"
          label="Wpisz szukaną frazę"
          clearable
          @click:clear="clearSearch"
          @click:append-outer="searchInit"
          v-on:keyup.enter="searchInit"
          :error-messages="errors.collect('search_key')"
          v-validate="'min:3'"
          data-vv-name="search_key"
          data-vv-as="fraza"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SearchByUser from './SearchItems/SearchByUser.vue';
import SearchByTag from './SearchItems/SearchByTag.vue';
import SearchByDate from './SearchItems/SearchByDate.vue';

export default {
  name: 'files-search',
  components: {
    SearchByUser,
    SearchByDate,
    SearchByTag,
  },
  data: () => ({
    searchText: null,
  }),
  computed: {
    ...mapGetters('files', [
      'query',
    ]),
    ...mapGetters('user', [
      'details',
      'role',
    ]),
    clientId() {
      const { params } = this.$route;
      return params.clientId || this.details.client_id;
    },
    isSearchPage() {
      return this.$route.name === 'searchFiles';
    },
    singleParams() {
      return {
        client_id: this.clientId,
      };
    },
    isAdmin() {
      return this.role === 'admin' || this.role === 'super-admin';
    },
  },
  methods: {
    ...mapActions('files', [
      'setQuery',
    ]),
    setValidationMessages() {
      const dict = {
        custom: {
          search_key: {
            min: 'Pole fraza musi być długie na co najmniej 3 znaki.',
          },
        },
      };
      this.$validator.localize('pl', dict);
    },
    searchInit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.searchFile();
        }
      });
    },
    searchFile() {
      if (!this.isSearchPage) {
        this.setQuery(null);
      }
      const newQuery = {
        ...this.query,
        search: this.searchText,
      };
      this.setQuery(newQuery);
      this.$router.push({ path: `/pliki/klient/${this.clientId}/szukaj`, query: newQuery });
    },
    clearSearch() {
      this.searchText = null;
      const newQuery = {
        ...this.query,
      };
      if (newQuery.search) {
        delete newQuery.search;
      }
      this.$validator.reset();
      this.setQuery(newQuery);
      this.$router.push({ path: `/pliki/klient/${this.clientId}/szukaj`, query: newQuery });
    },
  },
  mounted() {
    this.setValidationMessages();
    const { query } = this.$route;
    this.searchText = query.search;
  },
};
</script>
